module.exports = __webpack_public_path__ + "img/3_complete.e808047c.png";